import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    UpdateSsoSettings as UpdateSsoSettingsMutation,
    UpdateSsoSettingsVariables as UpdateSsoSettingsVariables,
    UpdateSsoSettingsInput,
} from 'nutshell-graphql-types';

import UPDATE_SSO_SETTINGS from '../mutations/update-sso-settings.graphql';

export const useUpdateSsoSettings = (): {
    updateSsoSettings: (arg1: UpdateSsoSettingsInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [updateSsoSettings, {loading, error}] = useMutation<
        UpdateSsoSettingsMutation,
        UpdateSsoSettingsVariables
    >(UPDATE_SSO_SETTINGS);

    return {
        updateSsoSettings: (input: UpdateSsoSettingsInput) =>
            updateSsoSettings({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
